import { RelatedObjectsController } from './related-objects.controller';
import { RelatedObjectsProps } from './related-objects.model';

export const RelatedObjects = (props: RelatedObjectsProps) => {
  return <RelatedObjectsController {...props} />;
};
